import React from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Card, Box, Typography, Link } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import RouteHelpAlert from './RouteHelpAlert';
import env from '../../../../config/env';

function EnabledRouteEmptyState() {
  const { t } = useTranslation(['description']);
  const scheduleLink = env.ROUTE_SCHEDULE_LINK || '#wrong-link';

  return (
    <>
      <Card sx={{ textAlign: 'center', py: 3, mb: 2 }}>
        <Box sx={{ textAlign: 'center' }}>
          <AccessTimeIcon
            sx={{
              fontSize: 48,
              width: 48,
              height: 48,
              color: 'text.secondary',
              mb: 2,
              mx: 'auto',
            }}
          />

          <Typography
            variant="h6"
            sx={{ mb: 1, fontWeight: 'semibold', fontSize: 20 }}
          >
            {t('routes.info.empty_routes_message_title', { ns: 'description' })}
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: 14 }}
          >
            <Trans
              t={t}
              i18nKey="routes.info.empty_routes_message_description"
              ns="description"
              components={[
                <Box component="span" sx={{ display: 'block', mb: 3 }} />,
                <Link
                  href={scheduleLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: 'primary.main',
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                  }}
                />,
              ]}
            />
          </Typography>
        </Box>
      </Card>
      <RouteHelpAlert />
    </>
  );
}

export default EnabledRouteEmptyState;
